<template>

	<div :class="messageClasses" @click.stop="onMessageClick">
		<div class="message-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TEXT">
			{{ tipText }}
		</div>
		<div class="message-tip" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">
			{{ $date.toChatTimeText(msgInfo.sendTime) }}
		</div>
		<div class="message-normal " v-else-if="isNormal" :class="{ 'message-mine': mine }">
			<!-- 修改复选框显示条件：转发模式下所有都显示，撤回模式下只显示有权限的 -->
			<div v-if="multiSelectMode && (multiSelectModeType === 'forward' || canRecall)" class="multi-select-checkbox" :class="{ 'checked': isSelected }">
				<i v-if="isSelected" class="el-icon-check"></i>
			</div>
			<div class="avatar">
				<head-image :name="showName" :size="38" :url="headImage" :id="msgInfo.sendId" :group="group"
					:is-show-user-info="!canAtSender" @click.native.stop="onAvatarClick"></head-image>
			</div>
			<div class="content">
				<div v-if="msgInfo.groupId && !msgInfo.selfSend" class="top">
					<div class="show-name">{{ showName }}</div>
					<el-tag v-if="isGroupOwner(msgInfo.sendId)" size="mini" type="danger">群主</el-tag>
					<el-tag v-if="isGroupManager(msgInfo.sendId)" size="mini" type="primary">管理员</el-tag>
				</div>
				<div class="bottom" :class="{ fullscreen: configStore.fullScreen }"
					@contextmenu.prevent="showMessageMenu($event)">
					<div ref="chatMsgBox" class="message-content-wrapper">
						<div class="message-text" v-if="isTextMessage" v-html="htmlText">
						</div>
						<div class="message-image" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.IMAGE"
							@click="showFullImageBox()">
							<div class="image-container" :style="imageStyle">
								<img class="send-image" :src="cachedThumbUrl || contentData.thumbUrl" loading="lazy" />
								<div class="image-overlay">
									<i class="el-icon-zoom-in"></i>
								</div>
							</div>
						</div>
						<div class="message-video" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.VIDEO">
							<video class="send-video" :style="imageStyle" controls preload="none"
								:poster="contentData.coverUrl" :src="contentData.videoUrl" />
						</div>
						<div class="message-file" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE">
							<div class="file-box" v-loading="sending">
								<div class="file-info">
									<el-link class="file-name" :underline="true" target="_blank" type="primary"
										:href="contentData.url" :download="contentData.name">{{ contentData.name
										}}</el-link>
									<div class="file-size">{{ fileSize }}</div>
								</div>
								<div class="file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
						</div>
						<div class="message-voice" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO"
							@click="onPlayVoice()">
							<audio controls :src="contentData.url"></audio>
						</div>
						<div title="发送中" v-if="sending" class="sending" v-loading="sending"></div>
						<div title="发送失败" v-else-if="sendFail" @click="onSendFail" class="send-fail el-icon-warning">
						</div>
					</div>
					<chat-user-card v-if="msgInfo.type == $enums.MESSAGE_TYPE.USER_CARD"
						:cardInfo="contentData"></chat-user-card>
					<chat-group-card v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.GROUP_CARD" :cardInfo="contentData"
						:sendTime="msgInfo.sendTime"></chat-group-card>
					<div class="chat-action message-text" v-else-if="isAction">
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-voice"></span>
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-video"></span>
						<span>{{ msgInfo.content }}</span>
					</div>
					<div class="quote-message" v-if="msgInfo.quoteMessage"
						@contextmenu.prevent.stop="showQuoteMenu($event)">
						<chat-quote-message :msgInfo="msgInfo.quoteMessage"
							@click.native.stop="$emit('locateQuote', msgInfo)"
							:showName="quoteShowName"></chat-quote-message>
					</div>
					<div class="message-status" v-if="!isAction && msgInfo.selfSend && !isGroupMessage">
						<span class="chat-readed" v-if="msgInfo.status == $enums.MESSAGE_STATUS.READED">已读</span>
						<span class="chat-unread" v-else>未读</span>
					</div>
					<div class="chat-receipt" v-if="msgInfo.receipt" @click="onShowReadedBox">
						<span v-if="msgInfo.receiptOk" class="icon iconfont icon-ok" title="全体已读"></span>
						<span v-else>{{ msgInfo.readedCount }}人已读</span>
					</div>
				</div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<chat-group-readed ref="chatGroupReadedBox" :msgInfo="msgInfo" :group="group"
			:groupMembers="groupMembers"></chat-group-readed>
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import ChatGroupReaded from './ChatGroupReaded.vue';
import ChatQuoteMessage from "./ChatQuoteMessage.vue";
import ChatUserCard from "./ChatUserCard.vue";
import ChatGroupCard from "./ChatGroupCard.vue";
import { getCachedImageUrl } from '../../utils/imageCache.js';
export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu,
		ChatGroupReaded,
		ChatQuoteMessage,
		ChatUserCard,
		ChatGroupCard
	},
	props: {
		mode: {
			type: Number,
			default: 1
		},
		active: {
			type: Boolean,
			default: false
		},
		mine: {
			type: Boolean,
			required: true
		},
		// 多选模式相关props
		multiSelectMode: {
			type: Boolean,
			default: false
		},
		multiSelectModeType: {
			type: String,
			default: 'forward'
		},
		headImage: {
			type: String,
			default: ''
		},
		showName: {
			type: String,
			required: true
		},
		quoteShowName: {
			type: String,
			default: ''
		},
		msgInfo: {
			type: Object,
			required: true
		},
		group: {
			type: Object,
			default: null
		},
		groupMembers: {
			type: Array,
			default: () => []
		},
		isSelected: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			cachedThumbUrl: '',
			cachedOriginUrl: ''
		}
	},
	methods: {
		async refreshCachedImageUrls() {
			if (this.msgInfo.type !== this.$enums.MESSAGE_TYPE.IMAGE) {
				this.cachedThumbUrl = '';
				this.cachedOriginUrl = '';
				return;
			}
			const data = this.contentData || {};
			const thumbUrl = data.thumbUrl || '';
			const originUrl = data.originUrl || thumbUrl;
			this.cachedThumbUrl = thumbUrl;
			this.cachedOriginUrl = originUrl;
			const [cachedThumbUrl, cachedOriginUrl] = await Promise.all([
				getCachedImageUrl(thumbUrl),
				getCachedImageUrl(originUrl)
			]);
			if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.IMAGE) {
				this.cachedThumbUrl = cachedThumbUrl;
				this.cachedOriginUrl = cachedOriginUrl;
			}
		},
		parseJSONSafely(value) {
			if (!value) return null;
			if (typeof value === 'object') return value;
			if (typeof value !== 'string') return null;
			try {
				return JSON.parse(value);
			} catch (error) {
				return null;
			}
		},
		formatQuotedName(name) {
			return name ? `“${name}”` : '';
		},
		getDisplayNameByAccountId(accountId) {
			if (!accountId) return '';
			const selfInfo = this.userStore.userInfo || {};
			if ([selfInfo.imAccid, selfInfo.accountId, selfInfo.id].some(id => String(id || '') === String(accountId))) {
				return selfInfo.nickName || selfInfo.userName || '你';
			}
			const member = (this.groupMembers || []).find(item => {
				return [item.userId, item.accountId, item.imAccid].some(id => String(id || '') === String(accountId));
			});
			const memberName = member?.showNickName || member?.nickName || '';
			if (memberName && !this.isIdLikeName(memberName, accountId)) {
				return memberName;
			}
			const friend = this.friendStore.findFriend(accountId);
			const friendName = friend?.remarkNickName || friend?.showNickName || friend?.nickName || '';
			return friendName && !this.isIdLikeName(friendName, accountId) ? friendName : '';
		},
		isIdLikeName(name, accountId = '') {
			const value = String(name || '');
			if (!value) return true;
			if (accountId && value === String(accountId)) return true;
			return /^[a-f0-9]{24,}$/i.test(value) || /^[0-9]{8,}$/.test(value);
		},
		getNotificationUserName(accountId, rawUserMap = {}) {
			const rawName = rawUserMap[accountId] || '';
			if (rawName && !this.isIdLikeName(rawName, accountId)) {
				return rawName;
			}
			return this.getDisplayNameByAccountId(accountId);
		},
		formatTeamNotificationText() {
			const sourceMessage = this.msgInfo.sourceMessage || {};
			const attachment = this.msgInfo.attachment || sourceMessage.attachment || sourceMessage.attach || {};
			const rawAttachment = this.parseJSONSafely(attachment.raw || sourceMessage.rawAttachment) || {};
			const rawData = rawAttachment.data || attachment.data || {};
			const notificationType = Number(attachment.type ?? rawAttachment.id ?? attachment.id);
			const rawUsers = rawData.uinfos || rawData.users || [];
			const rawUserMap = {};
			rawUsers.forEach(user => {
				const accountId = user.account || user.accid || user['1'];
				const nickName = user.nick || user.name || user['3'] || accountId;
				if (accountId) rawUserMap[accountId] = nickName;
			});
			const senderAccountId = this.msgInfo.sendId || sourceMessage.senderId || rawData.operatorAccountId || rawData.operator || rawData.fromAccountId || '';
			const senderName = !this.isIdLikeName(this.msgInfo.sendNickName, senderAccountId)
				? this.msgInfo.sendNickName
				: this.getNotificationUserName(senderAccountId, rawUserMap);
			const rawTargetIds = attachment.targetIds || rawData.ids || (rawData.id ? [rawData.id] : []);
			const targetIds = Array.isArray(rawTargetIds) ? rawTargetIds : [rawTargetIds];
			const targetNames = targetIds.map(id => this.getNotificationUserName(id, rawUserMap)).filter(Boolean);
			const fallbackText = this.msgInfo.content || sourceMessage.text || sourceMessage.content || rawData.msg || rawAttachment.msg || '';
			const quotedSenderName = this.formatQuotedName(senderName);
			const quotedTargetNames = targetNames.map(name => this.formatQuotedName(name));
			const muteStatus = rawData.mute ?? attachment.chatBanned;
			const hasMuteStatus = muteStatus === 0 || muteStatus === 1 || muteStatus === true || muteStatus === false;
			const chatBannedMode = Number(attachment?.updatedTeamInfo?.chatBannedMode ?? rawData?.tinfo?.chatBannedMode ?? rawData?.tinfo?.['17']);
			const hasChatBannedMode = chatBannedMode === 0 || chatBannedMode === 1 || chatBannedMode === 3;

			if (notificationType === 3 && hasChatBannedMode) {
				const banned = chatBannedMode === 1 || chatBannedMode === 3;
				return quotedSenderName
					? `${quotedSenderName}${banned ? '开启了全员禁言' : '关闭了全员禁言'}`
					: (banned ? '开启了全员禁言' : '关闭了全员禁言');
			}

			if ((notificationType === 0 || notificationType === 10) && hasMuteStatus) {
				if (quotedTargetNames.length > 0) {
					return muteStatus === 1 || muteStatus === true
						? `${quotedSenderName}禁言了${quotedTargetNames.join('、')}`
						: `${quotedSenderName}解除了${quotedTargetNames.join('、')}的禁言`;
				}
				return muteStatus === 1 || muteStatus === true ? '有成员被禁言' : '有成员被解除禁言';
			}

			switch (notificationType) {
				case 1:
				case 5:
				case 6:
				case 16:
				case 18:
					if (quotedSenderName && quotedTargetNames.length > 0) {
						return `${quotedTargetNames.join('、')}被${quotedSenderName}移出群聊`;
					}
					return quotedTargetNames.length > 0 ? `${quotedTargetNames.join('、')}被移出群聊` : '有成员被移出群聊';
				case 2:
				case 17:
				case 0:
					if (quotedTargetNames.length > 0) {
						return `${quotedSenderName}邀请${quotedTargetNames.join('、')}加入群聊`;
					}
					return quotedSenderName ? `${quotedSenderName}邀请成员加入群聊` : '有成员被邀请加入群聊';
				default:
					if (/邀请|移出群聊|被移除|禁言/.test(fallbackText)) {
						return fallbackText;
					}
					return fallbackText || '群成员变更通知';
			}
		},
		onSendFail() {
			this.$emit("resend", this.msgInfo);
		},
		showFullImageBox() {
			let imageUrl = this.cachedOriginUrl || this.contentData.originUrl;
			if (imageUrl) {
				this.$eventBus.$emit("openFullImage", imageUrl);
			}
		},
		onPlayVoice() {
			if (!this.audio) {
				this.audio = new Audio();
			}
			this.audio.src = this.contentData.url;
			this.audio.play();
			this.onPlayVoice = 'RUNNING';
		},
		// 在showMessageMenu方法中，在撤回选项后添加多选撤回选项
		showMessageMenu(e) {
		    let menuItems = [];
		    if (this.isTextMessage) {
		        menuItems.push({
		            key: 'COPY',
		            name: '复制'
		        });
		    }
		    menuItems.push({
		        key: 'DELETE',
		        name: '删除'
		    });
		    if (this.msgInfo.id) {
		        if (this.isOwner || this.isManager || this.msgInfo.selfSend) {
		            menuItems.push({
		                key: 'RECALL',
		                name: '撤回'
		            });
		            // 添加多选撤回选项
		            menuItems.push({
		                key: 'RECALL_MULTI',
		                name: '多选撤回'
		            });
		        }
		        if (this.$msgType.isNormal(this.msgInfo.type)) {
		            menuItems.push({
		                key: 'QUOTE',
		                name: '引用'
		            });
		            // 添加转发选项
		            menuItems.push({
		                key: 'FORWARD',
		                name: '转发'
		            });
		            // 添加多选转发选项
		            menuItems.push({
		                key: 'FORWARD_MULTI',
		                name: '多选转发'
		            });
		        }
		        if (this.isGroupMessage && (this.isOwner || this.isManager) && this.$msgType.isNormal(this.msgInfo.type)) {
		            menuItems.push({
		                key: 'TOP',
		                name: '置顶消息'
		            });
		        }
		    }
		    this.$refs.rightMenu.open(e, menuItems);
		},
		
		// 在onSelectMenu方法中添加对多选撤回的处理
		onSelectMenu(item) {
		    // 处理菜单选择
		    if (item.key === 'FORWARD') {
		        this.$emit('forward', this.msgInfo);
		    } else if (item.key === 'FORWARD_MULTI') {
		        console.log('触发startMultiForward事件');
		        this.$emit('start-multi-forward'); // 修改为kebab-case格式
		    } else if (item.key === 'RECALL_MULTI') {
		        // 触发多选撤回模式
		        this.$emit('start-multi-recall');
		    } else {
		        // 菜单id转驼峰作为事件key
		        let eventKey = item.key.toLowerCase().replace(/_([a-z])/g, (g) => g[1].toUpperCase());
		        this.$emit(eventKey, this.msgInfo);
		    }
		},
		showQuoteMenu(e) {
			let menuItems = [];
			if (this.msgInfo.quoteMessage &&
				this.msgInfo.quoteMessage.status != this.$enums.MESSAGE_STATUS.RECALL) {
				menuItems.push({
					key: 'LOCATE_QUOTE',
					name: '定位到原消息'
				});
			}
			this.$refs.rightMenu.open(e, menuItems);
		},
		onMessageClick() {
			// 修改点击消息的逻辑
			if (this.multiSelectMode) {
				// 根据模式类型决定是否检查权限
				if (this.multiSelectModeType === 'recall') {
					if (this.canRecall) {
						this.$emit('select-message', this.msgInfo);
					}
				} else {
					// 转发模式下所有消息都可以选中
					this.$emit('select-message', this.msgInfo);
				}
			}
		},
		onShowReadedBox() {
			let rect = this.$refs.chatMsgBox.getBoundingClientRect();
			this.$refs.chatGroupReadedBox.open(rect);
		},
		isGroupOwner(userId) {
			return this.group.ownerId == userId;
		},
		isGroupManager(userId) {
			let m = this.groupMembers.find(m => m.userId == userId);
			return m && m.isManager
		},
		onAvatarClick() {
			if (!this.canAtSender) {
				return;
			}
			this.$emit('at-user', this.senderMember);
		}
	},
	mounted() {
		this.refreshCachedImageUrls();
	},
	watch: {
		'msgInfo.content'() {
			this.refreshCachedImageUrls();
		},
		'msgInfo.type'() {
			this.refreshCachedImageUrls();
		}
	},
	// Fix the nested computed object issue
	computed: {
		mineAccountIds() {
			const mine = this.userStore.userInfo || {};
			return [mine.id, mine.imAccid, mine.accountId, mine.userName, this.$yunxinIM?.currentAccount]
				.filter(id => id !== undefined && id !== null && id !== '')
				.map(id => String(id));
		},
		myGroupMember() {
			return (this.groupMembers || []).find(member => {
				return [member.userId, member.id, member.accountId, member.imAccid]
					.some(id => this.mineAccountIds.includes(String(id || '')));
			});
		},
		senderMember() {
			const senderId = this.msgInfo.sendId;
			const member = (this.groupMembers || []).find(item => {
				return [item.userId, item.id, item.accountId, item.imAccid]
					.some(id => String(id || '') === String(senderId || ''));
			});
			return member || {
				userId: senderId,
				showNickName: this.showName,
				nickName: this.showName
			};
		},
	    sending() {
	        return this.msgInfo.status == this.$enums.MESSAGE_STATUS.SENDING;
	    },
	    sendFail() {
	        return this.msgInfo.status == this.$enums.MESSAGE_STATUS.FAILED;
	    },
	    // 新增多选状态样式
	    messageClasses() {
	        return {
	            'chat-message-item': true,
	            'active': this.active,
	            'multi-select-mode': this.multiSelectMode,
	            'multi-selected': this.multiSelectMode && this.isSelected
	        };
	    },
	    contentData() {
	        return JSON.parse(this.msgInfo.content)
	    },
	    fileSize() {
	        let size = this.contentData.size;
	        if (size > 1024 * 1024) {
	            return Math.round(size / 1024 / 1024) + "M";
	        }
	        if (size > 1024) {
	            return Math.round(size / 1024) + "KB";
	        }
	        return size + "B";
	    },
	    isTextMessage() {
	        return this.msgInfo.type == this.$enums.MESSAGE_TYPE.TEXT
	    },
		tipText() {
			if (this.msgInfo.sourceMessage || this.msgInfo.attachment) {
				return this.formatTeamNotificationText();
			}
			return this.msgInfo.content || '群通知';
		},
	    isAction() {
	        return this.$msgType.isAction(this.msgInfo.type);
	    },
	    isNormal() {
	        const type = this.msgInfo.type;
	        return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
	    },
	    isOwner() {
	        const ownerId = this.group?.ownerId || this.group?.ownerAccountId;
	        if (ownerId && this.mineAccountIds.includes(String(ownerId))) {
	            return true;
	        }
	        return !!(this.myGroupMember && (this.myGroupMember.isOwner || Number(this.myGroupMember.role) === 1));
	    },
	    isManager() {
	        return !!(this.myGroupMember && (this.myGroupMember.isManager || Number(this.myGroupMember.role) === 2));
	    },
	    htmlText() {
	        let color = this.msgInfo.selfSend ? 'white' : '';
	        let text = this.$str.html2Escape(this.msgInfo.content)
	        text = this.$url.replaceURLWithHTMLLinks(text, color)
	        return this.$emo.transform(text, 'emoji-normal')
	    },
	    isGroupMessage() {
	        return !!(this.msgInfo.groupId || this.group?.id || this.group?.teamId);
	    },
		canAtSender() {
			return this.isGroupMessage && !this.msgInfo.selfSend && !this.multiSelectMode && !!this.msgInfo.sendId;
		},
	    // 计算图片的显示宽高
	    imageStyle() {
	        let maxSize = this.configStore.fullScreen ? 360 : 240;
	        let minSize = 60;
	        let width = this.contentData.width;
	        let height = this.contentData.height;
	        if (width && height) {
	            let ratio = Math.min(width, height) / Math.max(width, height);
	            let w = Math.max(Math.min(width > height ? maxSize : ratio * maxSize, width), minSize);
	            let h = Math.max(Math.min(width > height ? ratio * maxSize : maxSize, height), minSize);
	            return `width: ${w}px;height:${h}px;object-fit: cover;`
	        } else {
	            return `max-width: ${maxSize}px;min-width:60px;max-height: ${maxSize}px;min-height:60px;`
	        }
	    },
	    // 添加canRecall计算属性
	    canRecall() {
	        // 判断条件：群主、管理员或自己发送的消息可以撤回
	        return this.isOwner || this.isManager || this.msgInfo.selfSend;
	    }
	}
}
</script>

<style lang="scss">
.chat-message-item {
	padding: 3px 10px;
	border-radius: 10px;

	&.active.onActive {
		background: var(--im-background-active-dark);
	}
	
	/* 多选模式样式 */
	.multi-select-mode {
		position: relative;
		cursor: pointer;
	}
	
	/* 为多选模式下的消息项增加内边距和调整头像位置 */
	.chat-message-item.multi-select-mode .message-normal {
		/* 默认情况 - 自己的消息 */
		padding-left: 78px !important;
		padding-right: 0 !important;
		
		.avatar {
			left: 25px !important;
		}
	}
	
	/* 他人消息的特殊处理 */
	.chat-message-item.multi-select-mode .message-normal:not(.message-mine) {
		padding-left: 0 !important;
		padding-right: 78px !important;
		
		.avatar {
			left: auto !important;
			right: 25px !important;
		}
	}
	
	/* 自己的消息保持原有样式 */
	.chat-message-item.multi-select-mode .message-normal.message-mine {
		padding-right: 78px !important;
		
		.avatar {
			right: 25px !important;
		}
	}
	
	/* 圆形勾选框样式 */
	.multi-select-checkbox {
		position: absolute;
		left: 0px; /* 默认在左侧，为自己的消息 */
		top: 50%;
		transform: translateY(-50%);
		width: 20px;
		height: 20px;
		border: 2px solid #dcdfe6;
		border-radius: 50%; /* 圆形 */
		background: white;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		color: white;
		z-index: 10;
		
		&.checked {
			border-color: #409eff;
			background: #409eff; /* 选中时背景色为主题色 */
		}
	}
	
	/* 他人消息时复选框放在右侧 */
	.message-normal:not(.message-mine) .multi-select-checkbox {
		left: auto;
		right: 0px;
	}
	
	/* 确保选中时的背景颜色样式优先级更高 */
	.chat-message-item.multi-selected {
		background: #ecf5ff !important;
		transition: background-color 0.2s ease;
	}

	.message-tip {
		line-height: 50px;
		font-size: var(--im-font-size-small);
		color: var(--im-text-color-light);
		word-break: break-word;
	}

	.message-normal {
		position: relative;
		font-size: 0;
		padding-left: 53px; /* 默认内边距，不考虑勾选框 */
		min-height: 50px;
		margin: 5px 0;

		.avatar {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0; /* 默认头像位置 */
			
			/* 多选模式下的头像位置调整 */
			.multi-select-mode & {
				left: 25px; /* 多选模式下头像右移 */
			}
		}

		.content {
				text-align: left;

			.top {
				display: flex;
				flex-wrap: nowrap;
				align-items: center;

				.show-name {
					white-space: nowrap;
					max-width: 400px;
					overflow: hidden;
					line-height: 18px;
					font-size: var(--im-font-size-small);
					color: #888;
				}
			}

			.bottom {
					display: inline-block;
					padding-right: 30px;
					margin-top: 2px;

				&.fullscreen {
					padding-right: 240px;
				}

				.message-content-wrapper {
					position: relative;
					display: inline-flex;
					align-items: flex-end;

					.sending {
						width: 25px;
						height: 25px;

						.circular {
							width: 25px;
							height: 25px;
						}
					}

					.send-fail {
						color: #e45050;
						font-size: 25px;
						cursor: pointer;
						margin: 0 5px;
					}
				}

				.message-text {
					flex: 1;
					display: inline-block;
					position: relative;
					line-height: 26px;
					padding: 6px 10px;
					background: var(--im-background);
					border-radius: 10px;
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-word;
				}

				.message-image {
					border-radius: 12px;
					overflow: hidden;
					cursor: pointer;
					background: var(--im-background);
					box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
					transition: all 0.3s ease;
					position: relative;

					&:hover {
						transform: translateY(-2px);
						box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
					}

					.image-container {
						position: relative;
						width: 100%;
						height: 100%;
						overflow: hidden;
						border-radius: 12px;

						.send-image {
							width: 100%;
							height: 100%;
							object-fit: cover;
							transition: transform 0.3s ease;
						}

						.image-overlay {
							position: absolute;
							top: 0;
							left: 0;
							right: 0;
							bottom: 0;
							background: rgba(0, 0, 0, 0.3);
							display: flex;
							align-items: center;
							justify-content: center;
							opacity: 0;
							transition: opacity 0.3s ease;

							i {
								color: white;
								font-size: 24px;
							}
						}


						&:hover {
							.send-image {
								transform: scale(1.05);
							}

							.image-overlay {
								opacity: 1;
							}
						}
					}
				}

				.message-video {
					border-radius: 12px;
					overflow: hidden;
					background: var(--im-background);
					box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
					transition: all 0.3s ease;

					&:hover {
						transform: translateY(-2px);
						box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
					}

					.send-video {
						width: 100%;
						height: 100%;
						object-fit: cover;
						transition: transform 0.3s ease;
					}

					&:hover .send-video {
						transform: scale(1.02);
					}
				}

				.message-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-bottom: 2px;
					background: var(--im-background);

					.file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						min-height: 60px;
						box-shadow: var(--im-box-shadow-light);
						border-radius: 8px;
						padding: 10px 15px;
						border: 2px solid #eee;

						transition: all 0.3s ease;
						background: white;

						&:hover {
							transform: translateY(-2px);
							box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
						}

						.file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;

							.file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 200px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
							}

							.file-size {
								font-size: var(--im-font-size-smaller);
								color: var(--im-text-color-light);
							}
						}

						.file-icon {
							font-size: 44px;
							color: #d42e07;
							transition: transform 0.3s ease;
						}

						&:hover .file-icon {
							transform: scale(1.1);
						}
					}
				}

				.message-voice {
					audio {
						height: 46px;
						cursor: pointer;
						border: 1px solid rgba(0, 0, 0, 0.08);
						border-radius: 23px;
						box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
						transition: all 0.3s ease;

						&:hover {
							transform: translateY(-1px);
							box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
						}
					}
				}

				.chat-action {
					display: flex;
					align-items: center;

					.iconfont {
						cursor: pointer;
						font-size: 22px;
						padding-right: 8px;
					}
				}

				.quote-message {
					display: block;
					margin-top: 3px;
					cursor: pointer;
				}

				.message-status {
					margin-top: 3px;
					display: block;
					font-size: 11px;

					.chat-readed {
						color: var(--im-text-color-light);
					}

					.chat-unread {
						color: var(--im-color-danger);
					}
				}

				.chat-receipt {
					font-size: var(--im-font-size-smaller);
					cursor: pointer;
					color: var(--im-text-color-light);

					.icon-ok {
						font-size: 20px;
						color: var(--im-color-success);
					}
				}

				.chat-at-user {
					padding: 2px 5px;
					border-radius: 3px;
					cursor: pointer;
				}
			}
		}

		&.message-mine {
			text-align: right;
			padding-left: 0;
			padding-right: 53px; /* 默认右侧内边距 */

			.avatar {
				left: auto;
				right: 0; /* 默认头像位置 */
			}
			.content {
				text-align: right;

				.top {
					flex-direction: row-reverse;
				}

				.bottom {
					padding-left: 30px;
					padding-right: 0;

					&.fullscreen {
						padding-left: 240px;
					}

					.message-content-wrapper {
						flex-direction: row-reverse;
					}

					.message-text {
						background-color: var(--im-color-primary-light-2);
						color: #fff;
					}

					.chat-action {
						flex-direction: row-reverse;

						.iconfont {
							transform: rotateY(180deg);
						}
					}
				}
			}
		}
	}
}
</style>
